export const getItemFromArrayByProbability = (
  arr: Array<{ possibility: number }>
): number => {
  const base: number[] = [];
  arr.forEach((element, index) => {
    for (let i = 0; i <= element.possibility; i++) {
      if (element.possibility > 0) {
        base.push(index);
      }
    }
  });
  return base[Math.floor(Math.random() * base.length)];
};
